import { ButtonGroup, ButtonIcon } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedMetadataAtom } from '../../../atoms/selectedMetadata';
import { videoSearchResultsAreUpdatingAtom } from '../../../atoms/videoListings';
import useVideoListings from '../../../hooks/videoListings';
import { CopyToClipboardWithIcon } from '../../Copy/Copy';
import RequestAlert from '../../RequestAlert';
import RequestDataSync from '../../RequestDataSync';

export function VideoSearchActions({ onClick }) {
  const intl = useIntl();

  const selectedMetadata = useAtomValue(selectedMetadataAtom);
  const { sport, matchId } = selectedMetadata;

  const { refreshVideoSearchResults } = useVideoListings();
  const videoSearchResultsAreUpdating = useAtomValue(
    videoSearchResultsAreUpdatingAtom,
  );

  const handleSearchClick = (event) => {
    if (onClick) {
      onClick(event);
    } else {
      refreshVideoSearchResults();
    }
  };

  return (
    <ButtonGroup>
      <ButtonIcon
        icon="Search"
        onClick={handleSearchClick}
        disabled={videoSearchResultsAreUpdating}
        isPending={videoSearchResultsAreUpdating}
        shape="pill"
        title={intl.formatMessage({
          defaultMessage: 'Search',
          id: '13348',
        })}
      />
      {sport && matchId && (
        <>
          <CopyToClipboardWithIcon
            icon="Share"
            text={`${window.location.origin}/download/${sport}/${matchId}`}
            title={intl.formatMessage({
              defaultMessage: 'Share',
              id: '5a95a',
            })}
          />
          <RequestAlert sport={sport} matchId={matchId} />
        </>
      )}
      {sport && matchId && <RequestDataSync matchId={matchId} />}
    </ButtonGroup>
  );
}

VideoSearchActions.propTypes = {
  onClick: PropTypes.func,
};

VideoSearchActions.defaultProps = {
  onClick: undefined,
};

export default VideoSearchActions;
